<template>
  <q-page>
    <div class="q-pa-md">
      <div class="row justify-between q-mb-sm">
        <div>
          <div class="row q-col-gutter-sm">
            <div class="page-title q-mr-sm">Solutions</div>
            <div class="col-auto">
              <q-btn
                color="primary"
                class="sustainability-button"
                @click="onAddSolutionClick"
              >
                <q-icon name="mdi-plus-circle"> </q-icon>
                <span
                  class="sustainability-font q-mx-sm"
                  style="font-size: 13px"
                >
                  Add
                </span>
              </q-btn>
            </div>
            <div class="col-auto">
              <q-btn
                color="secondary"
                class="sustainability-button"
                @click="downloadFindEntriesCSV"
              >
                <q-icon name="mdi-download"> </q-icon>
                <span
                  class="sustainability-font q-mx-sm"
                  style="font-size: 13px"
                >
                  Find Entries CSV
                </span>
              </q-btn>
            </div>
          </div>
        </div>
        <div class="row items-center justify-end q-mb-sm">
          <div>
            <q-select
              style="width: 300px"
              label="Filter By Empty"
              :options="emptyFilterOptions"
              multiple
              use-chips
              stack-label
              filled
              dense
              class="q-mr-sm"
              v-model="filterByEmpty"
            >
            </q-select>
          </div>
          <div>
            <q-select
              style="width: 200px"
              clearable
              filled
              dense
              label="Filter by Outcomes"
              v-model="filterByOutcome"
              :options="outcomesList"
              map-options
              option-label="name"
              emit-value
              class="q-mr-sm"
            >
            </q-select>
          </div>
          <div>
            <q-select
              clearable
              style="width: 140px"
              :options="progressStatusOptions"
              map-options
              option-label="description"
              option-value="color"
              emit-value
              label="Status Filter"
              filled
              dense
              class="q-mr-sm"
              v-model="filterByProgressStatus"
            >
              <template v-slot:option="scope">
                <q-item
                  dense
                  clickable
                  :active="scope.selected"
                  active-class="bg-primary"
                  @click="scope.toggleOption(scope.opt)"
                  v-bind="scope.itemProps"
                  v-on="scope.progressStatusOptions"
                >
                  <q-item-section avatar>
                    <q-avatar>
                      <q-img
                        :style="`background-color: ${scope.opt.color};width: 20px;height: 20px; border-radius: 100px;`"
                      ></q-img>
                    </q-avatar>
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:selected-item="scope">
                <div class="row items-center">
                  <q-img
                    class="q-mr-md"
                    :style="`background-color: ${scope.opt.color};width: 20px;height: 20px; border-radius: 100px;`"
                  ></q-img>
                </div>
              </template>
            </q-select>
          </div>
          <div>
            <q-input
              filled
              v-model="searchText"
              debounce="200"
              label="Search"
              clearable
              dense
            >
              <template #prepend>
                <q-icon name="mdi-magnify"></q-icon>
              </template>
            </q-input>
          </div>
        </div>
      </div>

      <div class="row justify-end q-mb-sm q-col-gutter-x-sm">
        <div class="col-6">
          <q-select
            v-model="filterByAreaOfBiz"
            label="Area Of the Business"
            @filter="filterAreaOfBiz"
            use-input
            use-chips
            :options="filteredAreaOfBizOptions"
            @input="checkIfAllAreaOfBiz"
            multiple
            dense
            filled
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
        <div class="col-4">
          <q-select
            v-model="filterByIndustry"
            label="Industry"
            @filter="filterIndustry"
            @input="checkIfAllIndustry"
            use-input
            dense
            filled
            use-chips
            :options="filteredIndustryOptions"
            multiple
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
        <div class="col-2">
          <q-checkbox
            v-model="filterByQuickWin"
            label="Quick Wins"
          ></q-checkbox>
        </div>
      </div>

      <div class="row">
        <q-card class="full-width">
          <div class="row">
            <div class="col-12 mt-0 pt-0" style="height: calc(100vh - 195px)">
              <data-table
                flat
                headerBgColor="#162c47"
                headerTextColor="white"
                :columns="columns"
                :data="filteredData"
                @rowDoubleClick="onRowDoubleClick"
                :pagination="{
                  sortBy: 'title',
                  descending: false,
                  rowsPerPage: 0,
                }"
              >
                <template slot="body-cell-image" slot-scope="data">
                  <q-td :props="data.props">
                    <q-icon
                      size="sm"
                      v-if="data.props.row.imageUrl"
                      name="mdi-check-circle"
                      color="green"
                    >
                    </q-icon>
                  </q-td>
                </template>
                <template slot="body-cell-description" slot-scope="data">
                  <q-td :props="data.props">
                    <q-icon
                      size="sm"
                      v-if="data.props.row.description"
                      name="mdi-check-circle"
                      color="green"
                    >
                    </q-icon>
                  </q-td>
                </template>
                <template slot="body-cell-actionsCount" slot-scope="data">
                  <q-td :props="data.props">
                    <q-icon
                      size="sm"
                      v-if="data.props.row.actionsCount > 0"
                      name="mdi-check-circle"
                      color="green"
                    >
                      <q-tooltip>{{ data.props.row.actionsCount }}</q-tooltip>
                    </q-icon>
                  </q-td>
                </template>

                <template slot="body-cell-findEntries" slot-scope="data">
                  <q-td :props="data.props">
                    <a
                      href="#"
                      v-if="
                        data.props.row.findEntries &&
                        data.props.row.findEntries.length > 0
                      "
                    >
                      <span class="text-center sourceLength">
                        {{
                          data.props.row.findEntries.length > 0
                            ? data.props.row.findEntries.length
                            : ""
                        }}
                        <q-menu
                          auto-close
                          max-height="400"
                          anchor="bottom right"
                          self="bottom right"
                        >
                          <q-list>
                            <q-item
                              v-for="(find, i) in data.props.row.findEntries"
                              :key="i"
                              clickable
                              @click="routeToFind(find)"
                            >
                              <q-item-section>
                                {{ find.supplierName }}
                              </q-item-section>
                            </q-item>
                          </q-list>
                        </q-menu>
                      </span>
                    </a>
                    <span v-else class="text-center sourceLength"> </span>
                  </q-td>
                </template>
                <template slot="body-cell-progressStatus" slot-scope="data">
                  <q-td :props="data.props">
                    <q-img
                      :style="`background-color: ${data.props.row.progressStatus};width: 20px;height: 20px; border-radius: 100px;`"
                    >
                      <q-tooltip>
                        {{
                          getStatusDescription(data.props.row.progressStatus)
                        }}
                      </q-tooltip>
                    </q-img>
                  </q-td>
                </template>
                <template slot="body-cell-imageStatus" slot-scope="data">
                  <q-td :props="data.props">
                    <q-img
                      :style="`background-color: ${data.props.row.imageStatus};width: 20px;height: 20px; border-radius: 100px;`"
                    >
                      <q-tooltip>
                        {{
                          getImageStatusDescription(data.props.row.imageStatus)
                        }}
                      </q-tooltip>
                    </q-img>
                  </q-td>
                </template>
                <template slot="body-cell-outcomes" slot-scope="data">
                  <q-td :props="data.props">
                    <div class="row items-center">
                      <div
                        v-for="(outcome, i) in data.props.row.outcomes"
                        :key="i"
                        class="q-mr-sm"
                      >
                        <q-img
                          class="q-mx-auto"
                          style="width: 30px; height: 30px"
                          :src="getOutcomeImage({ name: outcome.name })"
                        >
                        </q-img>
                      </div>
                    </div>
                  </q-td>
                </template>
                <template slot="body-cell-estimatedCost" slot-scope="data">
                  <q-td :props="data.props">
                    <div class="q-mr-sm">
                      <div class="row justify-center">
                        <div class="q-mr-sm">
                          <q-img
                            src="statics/money-icon.svg"
                            :style="`width: 30px; height: 30px;opacity:${
                              !data.props.row.cost ? '0.5' : '1'
                            }`"
                          ></q-img>
                        </div>
                        <div class="q-mr-sm">
                          <q-img
                            src="statics/money-icon.svg"
                            :style="`width: 30px; height: 30px; opacity:${
                              !data.props.row.cost ||
                              data.props.row.cost == 'Low'
                                ? '0.5'
                                : '1'
                            }`"
                          ></q-img>
                        </div>
                        <div class="q-mr-sm">
                          <q-img
                            src="statics/money-icon.svg"
                            :style="`width: 30px; height: 30px; opacity:${
                              !data.props.row.cost ||
                              data.props.row.cost != 'High'
                                ? '0.5'
                                : '1'
                            }`"
                          ></q-img>
                        </div>
                      </div>
                    </div>
                  </q-td>
                </template>
                <template slot="body-cell-difficulty" slot-scope="data">
                  <q-td :props="data.props">
                    <div class="q-mr-sm">
                      <div class="row justify-center">
                        <div class="q-mr-sm">
                          <q-img
                            src="statics/work-icon.svg"
                            :style="`width: 30px; height: 30px;opacity:${
                              !data.props.row.ease ? '0.5' : '1'
                            }`"
                          ></q-img>
                        </div>
                        <div class="q-mr-sm">
                          <q-img
                            src="statics/work-icon.svg"
                            :style="`width: 30px; height: 30px; opacity:${
                              !data.props.row.ease ||
                              data.props.row.ease == 'Low'
                                ? '0.5'
                                : '1'
                            }`"
                          ></q-img>
                        </div>
                        <div class="q-mr-sm">
                          <q-img
                            src="statics/work-icon.svg"
                            :style="`width: 30px; height: 30px; opacity:${
                              !data.props.row.ease ||
                              data.props.row.ease != 'High'
                                ? '0.5'
                                : '1'
                            }`"
                          ></q-img>
                        </div>
                      </div>
                    </div>
                  </q-td>
                </template>
                <template slot="body-cell-sources" slot-scope="data">
                  <q-td :props="data.props">
                    <a href="#" v-if="data.props.row.sources.length > 0">
                      <span class="text-center sourceLength">
                        {{ data.props.row.sources.length }}
                        <q-menu
                          auto-close
                          max-height="400"
                          anchor="bottom right"
                          self="bottom right"
                        >
                          <q-list>
                            <q-item
                              v-for="(source, i) in data.props.row.sources"
                              :key="i"
                              clickable
                              @click="routeToSource(source)"
                            >
                              <q-item-section>
                                {{ source.name }}
                              </q-item-section>
                            </q-item>
                          </q-list>
                        </q-menu>
                      </span>
                    </a>
                    <span v-else class="text-center sourceLength"> </span>
                  </q-td>
                </template>
                <template slot="body-cell-views" slot-scope="data">
                  <q-td :props="data.props">
                    <div class="row justify-center items-center">
                      <div>
                        <q-img
                          src="statics/eye-icon.svg"
                          :style="`width: 13px; height: 9px; color: #6CBD4F`"
                        >
                          <q-tooltip v-if="data.props.row.views">
                            {{
                              data.props.row.views ? data.props.row.views : 0
                            }}
                          </q-tooltip>
                        </q-img>
                      </div>

                      <span style="color: #6cbd4f" class="view-text">
                        ({{ data.props.row.views ? data.props.row.views : 0 }})
                      </span>
                    </div>
                  </q-td>
                </template>
                <template slot="body-cell-actions" slot-scope="data">
                  <q-td :props="data.props">
                    <q-btn
                      class="float-right"
                      round
                      flat
                      color="red"
                      icon="mdi-delete"
                      @click="removeSolution(data.props.row)"
                      size="md"
                    >
                    </q-btn>
                  </q-td>
                </template>
              </data-table>
            </div>
          </div>
        </q-card>
      </div>
    </div>
    <q-dialog v-model="solutionDialog" full-width full-height persistent>
      <solution-form
        ref="solutionForm"
        @closeDialog="solutionDialog = false"
        class="hide-scrollbar"
      ></solution-form>
    </q-dialog>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import DataTable from "@/components/datatable/datatable.vue";
  import SolutionForm from "@/components/solutions/solutionForm.vue";
  import { getOutcomeImage } from "@/functions/getOutcomeImage";
  import api from "@/api";
  export default {
    components: {
      DataTable,
      SolutionForm,
    },
    computed: {
      ...mapGetters({
        data: "solutions/list",
        actionsList: "solutionsActions/list",
        sources: "sources/list",
        sourcesData: "solutions/solutionsSourcesList",
        outcomesList: "outcomes/list",
        currentSolution: "solutions/selectedSolution",
      }),
      columns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 60px;max-width: 60px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "title",
            label: "Solution Title",
            align: "left",
            field: "title",
            style:
              "min-width:300px;max-width:300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "image",
            label: "Image",
            align: "center",
            field: "imageUrl",
          },
          {
            name: "description",
            label: "Description",
            align: "center",
            field: "description",
          },
          {
            name: "actionsCount",
            label: "Actions",
            align: "center",
            field: "actionsCount",
          },
          {
            name: "findEntries",
            label: "Find #",
            align: "center",
          },

          {
            name: "progressStatus",
            label: "Status",
            align: "left",
            field: "progressStatus",
            style:
              "min-width:100px;max-width:100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "imageStatus",
            label: "Img Status",
            align: "left",
            field: "imageStatus",
            style:
              "min-width:100px;max-width:100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "outcomes",
            label: "Outcomes",
            align: "left",
            field: "outcomes",
            style:
              "min-width:150px;max-width:150px;width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "sources",
            label: "Sources",
            align: "center",
            field: "sources",
            style:
              "min-width:80px;max-width:80px;width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "views",
            label: "Views",
            align: "center",
            field: "views",
            sortable: true,
            style:
              "min-width:80px;max-width:80px;width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "createdAt",
            label: "Created At",
            field: "created_at",
            align: "left",
            format: (val) => {
              return this.$options.filters.gridDateFormat(val);
            },
            style:
              "min-width:30px;max-width:30px;width:30px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            style:
              "min-width:80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },
      filteredData() {
        let currentData = this.data;

        //filter by outcome
        if (this.filterByOutcome) {
          currentData = currentData.filter((e) => {
            let outcomes = e.outcomes.map((o) => o.name);
            if (outcomes.includes(this.filterByOutcome.name)) {
              return e;
            }
          });
        }
        //filter by status
        if (this.filterByProgressStatus) {
          currentData = currentData.filter(
            (e) => e.progressStatus == this.filterByProgressStatus
          );
        }

        //filter by status
        if (this.filterByQuickWin) {
          currentData = currentData.filter((e) => e.quickWin);
        }

        //filter by industry
        currentData = currentData.filter((e) => {
          let totalCheck = 6;
          let checks = 0;
          if (this.filterByEmpty.includes("Find")) {
            if (e.findEntries.length <= 0) {
              checks += 1;
            }
          } else {
            checks += 1;
          }
          if (this.filterByEmpty.includes("Description")) {
            if (!e.description) {
              checks += 1;
            }
          } else {
            checks += 1;
          }
          if (this.filterByEmpty.includes("Image")) {
            if (!e.imageUrl) {
              checks += 1;
            }
          } else {
            checks += 1;
          }

          if (e.actionsCount == 0 || !this.filterByEmpty.includes("Actions")) {
            checks += 1;
          }

          if (this.filterByIndustry.length > 0 && e.industry) {
            let industry = JSON.parse(e.industry);

            if (this.filterByIndustry.includes("All")) {
              if (
                industry &&
                industry.length == this.industryOptions.length - 1
              ) {
                checks += 1;
              }
            } else {
              for (let i = 0; i < this.filterByIndustry.length; i++) {
                if (industry && industry.includes(this.filterByIndustry[i])) {
                  checks += 1;
                  break;
                }
              }
            }
          } else {
            checks += 1;
          }

          if (this.filterByAreaOfBiz.length > 0 && e.areaOfBusiness) {
            let areaOfBus = JSON.parse(e.areaOfBusiness);
            if (this.filterByAreaOfBiz.includes("All") && areaOfBus) {
              if (areaOfBus.length == this.areaOfBizOptions.length - 1) {
                checks += 1;
              }
            } else {
              for (let i = 0; i < this.filterByAreaOfBiz.length; i++) {
                if (areaOfBus && areaOfBus.includes(this.filterByAreaOfBiz[i])) {
                  checks += 1;
                  break;
                }
              }
            }
          } else {
            checks += 1;
          }

          if (checks == totalCheck) {
            return e;
          }
        });

        currentData = currentData.filter((e) => {
          let matchFound = !this.searchText;
          if (this.searchText) {
            let fieldsToSearch = ["title", "description", "id", "help"];

            fieldsToSearch.forEach((element) => {
              if (!matchFound) {
                let val = `${e[element]}`.toLowerCase();
                matchFound =
                  val.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
              }
            });
          }
          return matchFound;
        });
        return currentData;
      },
    },
    watch: {
      $route: {
        handler(value) {
          // if (value.params.hasOwnProperty("findEntriesID")) {
          //   this.openSelectedSolution(value.params.id);
          //   this.$refs.solutionForm.initialiseFindEntryData();
          // } else {
          if (value.params.hasOwnProperty("id")) {
            this.openSelectedSolution(value.params.id);
          }
          // }
        },
        deep: true,
      },
    },
    data: () => ({
      searchText: "",
      filterByOutcome: "",

      solutionDialog: false,

      //add solutions button
      addLoading: false,

      progressStatusOptions: [
        {
          color: "purple",
          description: "Text or Questions are needed",
          label: "Purple",
        },
        {
          color: "red",
          description: "Ready for revision",
          label: "Red",
        },
        {
          color: "orange",
          description: "Image needs replacing",
          label: "Orange",
        },
        {
          color: "green",
          description: "Complete and live",
          label: "Green",
        },
      ],
      imageStatusOptions: [
        {
          color: "purple",
          description: "Needing Image",
          label: "Purple",
        },
        {
          color: "blue",
          description: "Image needs checking",
          label: "Blue",
        },
        {
          color: "orange",
          description: "Image needs replacing",
          label: "Orange",
        },
        {
          color: "red",
          description: "Image needs re-checking",
          label: "Red",
        },
        {
          color: "green",
          description: "Image approved",
          label: "Green",
        },
      ],
      filterByEmpty: [],
      emptyFilterOptions: ["Find", "Image", "Description", "Actions"],
      filterByProgressStatus: "",
      filterByIndustry: [],
      filteredIndustryOptions: [],
      industryOptions: [
        "All",
        "Accommodation and Food Services",
        "Agriculture, Forestry and Fishing",
        "Arts and Recreation Services",
        "Construction",
        "Education and Training",
        "Electricity, Gas, Water and Waste Services",
        "Financial, Insurance & Administration Services",
        "Health Care and Social Assistance",
        "Information Media and Telecommunications",
        "Manufacturing",
        "Mining",
        "Professional, Scientific and Technical Services",
        "Rental, Hiring and Real Estate Services",
        "Retail Trade",
        "Transport, Postal and Warehousing",
        "Wholesale Trade",
        "Other",
      ],
      filterByAreaOfBiz: [],
      filteredAreaOfBizOptions: [],
      areaOfBizOptions: [
        "All",
        "Vehicles & Transport",
        "Shipping & Exporting",
        "Office & Building",
        "Site & Project",
        "Materials, Products & Assets",
        "Leadership & Strategy",
        "Environment-Related",
        "Other",
      ],

      filterByQuickWin: false,
    }),
    mounted() {
      this.$store.dispatch("solutions/loadAll");
      this.$store.dispatch("outcomes/loadAll");
      this.$store.dispatch("actionTemplates/loadAll");
      if (this.$route.params.hasOwnProperty("id")) {
        this.openSelectedSolution(this.$route.params.id);
      }
    },
    methods: {
      checkIfAllIndustry() {
        if (this.filterByIndustry.includes("All")) {
          this.filterByIndustry = this.filterByIndustry.filter((e) => e == "All");
        }
      },
      checkIfAllAreaOfBiz() {
        if (this.filterByAreaOfBiz.includes("All")) {
          this.filterByAreaOfBiz = this.filterByAreaOfBiz.filter(
            (e) => e == "All"
          );
        }
      },
      filterAreaOfBiz(val, update) {
        update(() => {
          if (val === "") {
            this.filteredAreaOfBizOptions = this.areaOfBizOptions;
          } else {
            const input = val.toLowerCase();
            this.filteredAreaOfBizOptions = this.areaOfBizOptions.filter(
              (e) => e.toLowerCase().indexOf(input) > -1
            );
          }
        });
      },
      filterIndustry(val, update) {
        update(() => {
          if (val === "") {
            this.filteredIndustryOptions = this.industryOptions;
          } else {
            const input = val.toLowerCase();
            this.filteredIndustryOptions = this.industryOptions.filter(
              (e) => e.toLowerCase().indexOf(input) > -1
            );
          }
        });
      },
      routeToSource(source) {
        this.$router.push("/sources/" + source.sources_id);
      },
      routeToFind(find) {
        this.$router.push(
          this.$route.path + "/" + find.solutions_id + "/findEntries/" + find.id
        );
      },
      getOutcomeImage: (outcome) => getOutcomeImage(outcome),
      getStatusDescription(color) {
        let index = this.progressStatusOptions.findIndex((e) => e.color == color);
        if (index > -1) {
          return this.progressStatusOptions[index].description;
        }
      },
      getImageStatusDescription(color) {
        let index = this.imageStatusOptions.findIndex((e) => e.color == color);
        if (index > -1) {
          return this.imageStatusOptions[index].description;
        }
      },

      async onAddSolutionClick() {
        let result = await this.$store.dispatch("solutions/new", {
          status: "temp",
        });
        this.addLoading = false;
        this.$router.push(
          "/solutions/" + parseFloat(result.Response.newSolutionId)
        );
      },
      onRowDoubleClick(row) {
        this.$router.push("/solutions/" + row.id);
      },
      async openSelectedSolution(id) {
        if (!this.currentSolution || id != this.currentSolution.id) {
          this.$store.commit("solutions/setSelectedSolution", null);
          this.$store.dispatch("solutions/loadSolutionByID", id);
        }
        this.$store.dispatch("outcomes/loadAll");
        this.$store.dispatch("solutions/findEntries/loadAllBySolutionsID", id);
        this.$store.dispatch("solutions/actions/loadAllBySolutionID", id);
        this.$store.dispatch("sources/loadAll");
        this.$store.dispatch("solutions/loadAllSolutionsSourcesBySolutionID", id);
        this.$store.dispatch("solutions/loadSolutionsImpactBySolutionID", id);

        this.$store.dispatch("solutions/articles/loadAllBySolutionID", id);
        this.solutionDialog = true;
      },
      removeSolution(solution) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let removedPayload = {
              ...solution,
              deleted_at: Date.now(),
            };

            let result = await this.$store.dispatch(
              "solutions/save",
              removedPayload
            );
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
              this.$store.dispatch("outcomes/loadAllOutcomesCategories");
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          }
        });
      },
      downloadFindEntriesCSV() {
        window.open(
          `${api.defaults.baseURL}/solutions/findEntries/download`,
          "_blank"
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  .page-title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
  }

  .sustainability-button {
    height: 34px;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 9px;
    line-height: 11px;
    display: flex;
    align-items: center;
    text-align: center;
  }

  .sourceLength {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
  }

  .hide-scrollbar {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
</style>

